export const darkNotificationProps = {
  iconcolor: "#ffffff", // React error if named iconColor
  color: "gray.7",
};
